<div class="search-container" *ngIf="zeigeSuche">
    <mat-card style="padding: 16px; max-width: 90vw">
        <mat-card-header>
            <mat-card-title>Neuen Kontakt hinzufügen</mat-card-title>
            <mat-card-subtitle>Suchen Sie nach VVVO-Nummer</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <mat-form-field appearance="outline" style="width: 100%; margin-top: 12px">
                <mat-label>VVVO-Nummer</mat-label>
                <input
                    matInput
                    [formControl]="suchControl"
                    placeholder="15-stellige VVVO-Nummer"
                    maxlength="15"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    (keypress)="onKeyPress($event)"
                    (paste)="onPaste($event)"
                />
                <span matSuffix class="search-suffix">
                    <mat-spinner *ngIf="ladeSuche" diameter="18"></mat-spinner>
                    <button
                        *ngIf="suchControl.value"
                        mat-icon-button
                        type="button"
                        class="search-clear-button"
                        aria-label="Clear search"
                        (click)="suchControl.setValue('')"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-icon class="search-suffix-icon">search</mat-icon>
                </span>
            </mat-form-field>

            <!-- Suchergebnisse -->
            <div *ngIf="suchErgebnisse.length > 0" style="margin-top: 16px">
                <h4>Suchergebnisse:</h4>
                <div *ngFor="let betrieb of suchErgebnisse" style="margin-bottom: 12px">
                    <mat-card style="padding: 12px">
                        <div class="one-row">
                            <div>
                                <h4 style="margin: 0">{{ betrieb.bezeichnung_final }}</h4>
                                <p style="margin: 4px 0; color: #666" *ngIf="betrieb.zusatz_final">{{
                                    betrieb.zusatz_final
                                }}</p>
                                <p style="margin: 4px 0; font-size: 0.9em">
                                    <mat-icon style="font-size: 16px; height: 16px; width: 16px">location_on</mat-icon>
                                    VVVO: {{ betrieb.vvvo }}
                                </p>
                                <p
                                    style="margin: 4px 0; font-size: 0.9em"
                                    *ngIf="betrieb.strasse || betrieb.plz || betrieb.ort"
                                >
                                    {{ betrieb.strasse }} {{ betrieb.plz }} {{ betrieb.ort }}
                                </p>
                            </div>
                            <span class="spacer"></span>
                            <div>
                                <button
                                    *ngIf="!istBereitsKontakt(betrieb)"
                                    mat-raised-button
                                    color="accent"
                                    (click)="fuegeKontaktHinzu(betrieb)"
                                    [disabled]="ladeErstelleKontakt"
                                >
                                    <mat-icon>add</mat-icon>
                                    Hinzufügen
                                </button>
                                <button
                                    *ngIf="isVvvoPlatzhalter(betrieb) && istBereitsKontakt(betrieb)"
                                    mat-raised-button
                                    color="accent"
                                    (click)="korrigierePlatzhalter(betrieb)"
                                    [disabled]="ladeErstelleKontakt"
                                    style="margin-left: 8px"
                                >
                                    <mat-icon>edit</mat-icon>
                                    Daten korrigieren
                                </button>
                                <span
                                    *ngIf="istBereitsKontakt(betrieb) && !isVvvoPlatzhalter(betrieb)"
                                    style="color: #4caf50; font-weight: 500"
                                >
                                    <mat-icon style="vertical-align: middle">check</mat-icon>
                                    Bereits hinzugefügt
                                </span>
                                <span
                                    *ngIf="istBereitsKontakt(betrieb) && isVvvoPlatzhalter(betrieb)"
                                    style="color: #4caf50; font-weight: 500; margin-right: 8px"
                                >
                                    <mat-icon style="vertical-align: middle">check</mat-icon>
                                    In Kontakten
                                </span>
                            </div>
                        </div>
                    </mat-card>
                </div>
            </div>

            <!-- Neuen Kontakt erstellen wenn keine Suchergebnisse -->
            <div
                *ngIf="
                    suchControl.value && suchControl.value.length === 15 && suchErgebnisse.length === 0 && !ladeSuche
                "
                style="margin-top: 16px; text-align: center; color: #666"
            >
                <mat-icon>search_off</mat-icon>
                <p>VVVO: {{ suchControl.value }} nicht gefunden</p>

                <!-- Neuen Kontakt erstellen Button -->
                <div style="margin-top: 16px">
                    <button
                        mat-raised-button
                        color="accent"
                        (click)="oeffneNeuenKontaktDialog()"
                        style="min-width: 150px"
                    >
                        <mat-icon>add</mat-icon>
                        Neuen Kontakt erstellen
                    </button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
